import React from 'react';

import '../assets/styles/style.css';
import homeAbout from '../assets/images/home-about.png';
import homeAbout2 from '../assets/images/home_about_2.jpg';
import {useTranslation} from "react-i18next";
import dompurify from "dompurify";

const HomeContent: React.FC<{ title?: any, subtitle?: any, buttonText?: any }> = ({title, subtitle, buttonText}) => {
    const {t} = useTranslation();
    return (
        <>
            <section className="description bg-white py-8 lg:pb-14 relative">
                <div className="description-brand">
                </div>
                <div className="build-exp mt-5 md:flex md:justify-between md:items-center 4xl-custom:items-start md:gap-12 lg:justify-start lg:gap-24 xl:gap-56">
                    <div className="build-exp-des py-3 px-5 md:pl-0 lg:pr-6 max-w-lg md:order-2 lg:flex-initial lg:w-4/6 lg:max-w-full 4xl-custom:mt-52">
                        <h2 className="build-exp-title font-secondary text-lg lg:text-21">{t('home:one.title')}</h2>

                        <p className="build-exp-txt my-2 text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl leading-normal lg:leading-normal xl-custom-1280:leading-normal 4xl-custom:leading-normal">
                            {/*<span className="description-highlight font-bold text-secondary">Technology designed</span> for your growth.*/}
                            {/*{t('home:one.content')}*/}
                            <div className={`description-highlight font-bold text-secondary`}
                                 dangerouslySetInnerHTML={{__html: dompurify.sanitize(t('home:one.content'))}}/>
                        </p>

                        <a href="/company-info" className="build-exp-link text-base inline-block text-secondary lg:text-lg">
                            <span className="flex justify-between items-center gap-2">
                                <span className="build-exp-link-txt link-underline link-underline-orange link-underline-b-4">{t('home:one.about_blue')}</span>
                                <span className="build-exp-icon self-baseline">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                                    </svg>
                                </span>
                            </span>
                        </a>
                    </div>

                    <div className="buil-exp-pic p-5 md:p-0 md:order-1 relative lg:flex-initial lg:w-2/6">
                        <img src={homeAbout} alt="We build experienceWe build experience" className="build-exp-img w-full align-middle hidden md:block"/>
                        {/*<img src={homeAbout} alt="We build experience" className="build-exp-img build-exp-img-absolute md:absolute"/>*/}
                    </div>

                </div>

                <div className="it-transformation md:flex md:justify-between md:items-center md:gap-4 my-8 md:mb-0 md:mt-40 lg:mt-60 xl-custom-1280:mt-80 xl-custom-1440:mt-96 xl:gap-14">

                    <div className="it-transformation-des py-3 px-5 max-w-xl md:flex-1 lg:flex-initial lg:w-3/5 md:pl-10 xl-custom-1440:pl-[50px] lg:max-w-full">

                        <h2 className="it-transformation-title font-secondary text-lg xl:text-21">{t('home:two.title')}</h2>


                        <p className="it-transformation-txt my-2 text-xl lg:text-2xl xl-custom-1280:text-3xl 4xl-custom:text-5xl leading-normal lg:leading-normal xl-custom-1280:leading-normal 4xl-custom:leading-normal">
                            <div className={`description-highlight font-bold text-secondary`}
                                 dangerouslySetInnerHTML={{__html: dompurify.sanitize(t('home:two.content'))}}/>
                        </p>
                    </div>


                    <div className="it-transformation-pic p-5 md:p-0 md:flex-1 lg:flex-initial lg:w-2/5">
                        <img src={homeAbout2} alt="Making IT Transformation" className="w-full h-auto"/>
                    </div>

                </div>
            </section>
        </>
    );
}

export default HomeContent;